import { useState, useEffect } from 'react';

export default function Background() {
  const [type, setType] = useState(() => localStorage.getItem("background_type") || "plain");

  useEffect(() => {
    const handleStorageChange = () => {
      setType(localStorage.getItem("background_type") || "plain");
    };

    // Initial load
    handleStorageChange();
    
    // Add a storage event listener
    window.addEventListener("storage", handleStorageChange);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <>
      {type === "grid" && (
        <div className="absolute inset-0 -z-10 bg-background dark:bg-[linear-gradient(to_right,#1f1f1f_1px,transparent_1px),linear-gradient(to_bottom,#1f1f1f_1px,transparent_1px)] bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
      )}
      {type === "dots" && (
        <div className="absolute inset-0 -z-10 h-full w-full bg-background bg-[radial-gradient(#cccccc_1px,transparent_1px)] dark:bg-[radial-gradient(#333333_1px,transparent_1px)] [background-size:32px_32px]"></div>
      )}
      {type === "gradient" && (
        <div className="absolute inset-0 -z-10 h-full w-full" style={{ background: "radial-gradient(125% 125% at 50% 10%, hsl(var(--background)) 40%, hsl(var(--primary)) 100%)" }}></div>
      )}
      {type === "muted" && (
        <div className="absolute inset-0 -z-10 h-full w-full bg-accent"></div>
      )}
      {type === "plain" && (
        <div className="absolute inset-0 -z-10 h-full w-full bg-background"></div>
      )}
    </>
  );
}